import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { YouTube } from 'src/components/molecules/YouTube'

export const TopVideo: React.VFC = () => {
  return (
    <Container>
      <YouTube caption="commmune紹介動画はこちら！" url="https://www.youtube.com/embed/GEjhwsdvDnk"/>
      <YouTube caption="CM公開中！" url="https://www.youtube.com/embed/BL60t3rpyuY"/>
    </Container>
  )
}

const Container = styled.div`
  padding: 0 0 ${Styles.spacing[11]};
  max-width: 990px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: ${Styles.spacing[10]};
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    padding: 0 50px ${Styles.spacing[13]};
    flex-direction: row;
  }
`
